/* Custom Input Component to be used with Formik */
import React, { useMemo } from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import {
  Text, FormErrorMessage, FormFieldInfo, FormFieldMaxLetters
} from 'components/atoms';
import RichTextEditorMarkdownInput from 'containers/RichTextEditorMarkdown/RichTextEditorMarkdownInput'

// this spacing is used below the error message, this makes the margin feel more natural
// when the error happears and disappears
const InputSpacingFix = styled.div`
  height: ${props => props.theme.spacing.m};
  width: 100%;
`;

const FieldArray = ({
  title,
  field,
  form: {
    errors, setFieldValue, touched, setFieldTouched
  },
  info,
  maxLetters,
  ...props
}) => {
  const isError = useMemo(() => touched[field.name] && errors[field.name], [
    touched,
    errors,
    field.name,
  ]);

  const handleChange = markdown => {
    setFieldValue(field.name, markdown);
  };

  const initialValue = useMemo(
    () => field.value,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return (
    <Styles>
      {title && (
        <Top>
          <Text modifiers={['base']}>{title}</Text>
          {maxLetters && <FormFieldMaxLetters value={field.value} maxLetters={maxLetters} />}
        </Top>
      )}
      <RichTextEditorMarkdownInput
        onEditorStateChange={handleChange}
        initialMarkdown={initialValue}
        {...field}
        {...props}
        onBlur={() => setFieldTouched(field.name)}
      />
      {isError && <FormErrorMessage>{errors[field.name]}</FormErrorMessage>}
      {info && <FormFieldInfo>{info}</FormFieldInfo>}
      <InputSpacingFix />
    </Styles>
  );
};

FieldArray.propTypes = {
  title: PropTypes.string,
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.any,
    onBlur: PropTypes.func,
  }).isRequired,
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({}),
    isSubmitting: PropTypes.bool,
    isValid: PropTypes.bool,
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
  }).isRequired,
  info: PropTypes.string,
  maxLetters: PropTypes.number,
  onBlur: PropTypes.func,
};

FieldArray.defaultProps = {
  title: null,
  info: null,
  maxLetters: null,
  onBlur: () => {}
};

const Top = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const Styles = styled.div`
  ${Text} {
    padding-bottom: ${props => props.theme.spacing.s};
  }
`;

export default FieldArray;
